// hooks/useTranscriptData.js - Updated to work with new structure
import { useMemo } from 'react';
import TranscriptPagingUtil from 'utils/TranscriptPagingUtil';
import SpeakerColorConstants from 'constants/SpeakerColorConstants';
import {
  buildParagraphs,
  createSpeakerColorHash
} from 'utils/ParagraphUtils';

export const useTranscriptData = (transcriptBody, page) => {
  // Build base paragraphs
  const paragraphs = useMemo(() => {
    if (!transcriptBody) return [];
    return buildParagraphs(transcriptBody);
  }, [transcriptBody]);

  // Create speaker color mapping
  const speakerColorHash = useMemo(() => {
    return createSpeakerColorHash(paragraphs, SpeakerColorConstants);
  }, [paragraphs]);

  // Calculate pagination info
  const paginationInfo = useMemo(() => {
    if (!transcriptBody) return { start: 0, end: 0, numberOfPages: 0 };
    
    const numberOfPages = TranscriptPagingUtil.getNumberOfPages(transcriptBody.length);
    const paragraphCount = paragraphs.length;
    const start = TranscriptPagingUtil.getPageStart(page, numberOfPages, paragraphCount);
    const end = TranscriptPagingUtil.getPageEnd(page, numberOfPages, paragraphCount);
    
    return { start, end, numberOfPages };
  }, [transcriptBody, paragraphs, page]);

  // Get visible paragraphs for current page
  const visibleParagraphs = useMemo(() => {
    return paragraphs.slice(paginationInfo.start, paginationInfo.end);
  }, [paragraphs, paginationInfo?.start, paginationInfo?.end]);

  return {
    paragraphs,
    speakerColorHash,
    paginationInfo,
    visibleParagraphs
  };
};
